/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiserviceMelcoModelsCustomWarning
 */
export interface ApiserviceMelcoModelsCustomWarning {
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsCustomWarning
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsCustomWarning
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsCustomWarning
     */
    message?: string | null;
}

export function ApiserviceMelcoModelsCustomWarningFromJSON(json: any): ApiserviceMelcoModelsCustomWarning {
    return ApiserviceMelcoModelsCustomWarningFromJSONTyped(json, false);
}

export function ApiserviceMelcoModelsCustomWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiserviceMelcoModelsCustomWarning {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function ApiserviceMelcoModelsCustomWarningToJSON(value?: ApiserviceMelcoModelsCustomWarning | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'source': value.source,
        'message': value.message,
    };
}


